// extracted by mini-css-extract-plugin
export default {"header":"ConvrtTabs_header__RWy21","tabs":"ConvrtTabs_tabs__bjKxf"};